
























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'

@Component
export default class ChangePasswordComponent extends Vue {
  @Prop({type: Object}) resource?: any
  @Prop({type: String, default: ''}) title!: string
  @Prop({type: String, default: ''}) description!: string
  @Prop({type: String, default: ''}) passwordType!: string
  @Prop({type: Boolean, default: false}) showSenhaAntiga!: boolean

  newPassword = ''
  confirmPassword = ''
  selected = false

  @Watch('newPassword', {immediate: true})
  @Watch('confirmPassword', {immediate: true})
  confirmEqualPasswords() {
    if (this.newPassword === this.confirmPassword && this.newPassword !== '') {
      this.resource[this.passwordType] = this.newPassword || null
      this.$emit('passwordsMatch', true)
    } else {
      this.$emit('passwordsMatch', false)
    }
  }

  @Watch('selected')
  selectedChanged() {
    if (!this.selected) {
      this.newPassword = ''
      this.confirmPassword = ''
      this.resource[this.passwordType] = null

      if (this.resource.senhaAntiga) {
        this.resource.senhaAntiga = null
      }
    }
  }

  get isUser() {
    return Helper.getUsuarioNome() !== ''
  }
}
